import { Playlist, SearchQueryDTO, Song } from '~/@types/tsl-types';

import { emptySplitApi } from './emptySplitApi';

export const searchApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    searchSongs: builder.query<Song[], SearchQueryDTO>({
      query: (params) => ({
        method: 'GET',
        url: 'songs',
        params,
      }),
    }),
    searchPlaylists: builder.query<Playlist[], SearchQueryDTO>({
      query: (params) => ({
        method: 'GET',
        url: 'playlists',
        params,
      }),
    }),
  }),
});

export const { useLazySearchSongsQuery, useLazySearchPlaylistsQuery } = searchApi;
